import React from 'react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import ConstructionIcon from '@mui/icons-material/Construction';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import '../ServicesMonitor.scss';

export default function ComingSoonSection() {
  return (
    <Paper className="sm-coming-soon-paper" elevation={0}>
      <Box className="sm-coming-soon-icon-wrapper">
        <ConstructionIcon sx={{ fontSize: 42, color: 'var(--color-primary)' }} />
      </Box>

      <Typography className="sm-coming-soon-title">HTTP Metrics - Coming Soon</Typography>

      <Typography className="sm-coming-soon-description" sx={{ color: 'text.secondary' }}>
        Detailed HTTP metrics monitoring for this service is currently under development. We&#39;re
        working on bringing you comprehensive request analytics, latency tracking, and performance
        insights.
      </Typography>

      <Box className="sm-coming-soon-features-list">
        <Box className="sm-coming-soon-feature-item">
          <TrendingUpIcon sx={{ fontSize: 20, color: 'var(--color-primary)' }} />
          Request Rate Analytics
        </Box>
        <Box className="sm-coming-soon-feature-item">
          <AccessTimeIcon sx={{ fontSize: 20, color: 'var(--color-primary)' }} />
          Latency Monitoring
        </Box>
        <Box className="sm-coming-soon-feature-item">
          <TrendingUpIcon sx={{ fontSize: 20, color: 'var(--color-primary)' }} />
          Error Rate Tracking
        </Box>
      </Box>
    </Paper>
  );
}
